import { useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { useOrganization } from '@/contexts/OrganizationContext';
import { useAuth } from '@/hooks/useAuth';
import { Layout } from '@/components/Layout';

interface OrganizationRouteProps {
  children: React.ReactNode;
}

export function OrganizationRoute({ children }: OrganizationRouteProps) {
  const { user, loading: authLoading } = useAuth();
  const { currentOrganization, organizations, isLoading: orgLoading, setCurrentOrganization } = useOrganization();
  const { orgSlug } = useParams<{ orgSlug: string }>();

  // useEffect MUST be before any conditional return (React Rules of Hooks)
  useEffect(() => {
    if (!orgSlug || organizations.length === 0) return;
    const orgFromRoute = organizations.find(o => o.slug === orgSlug);
    if (!orgFromRoute) return;
    if (!currentOrganization || currentOrganization.id !== orgFromRoute.id) {
      setCurrentOrganization(orgFromRoute);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgSlug, organizations.length]);

  if (authLoading || orgLoading) {
    return <div className="min-h-screen flex items-center justify-center">Carregando...</div>;
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  if (organizations.length === 0) {
    return <Navigate to="/onboarding" replace />;
  }

  if (!orgSlug) {
    const target = currentOrganization || organizations[0];
    return <Navigate to={`/org/${target.slug}`} replace />;
  }

  const orgFromRoute = organizations.find(o => o.slug === orgSlug);
  if (!orgFromRoute) {
    const target = currentOrganization || organizations[0];
    return <Navigate to={`/org/${target.slug}`} replace />;
  }

  if (!currentOrganization || currentOrganization.slug !== orgSlug) {
    return <div className="min-h-screen flex items-center justify-center">Carregando...</div>;
  }

  return <Layout>{children}</Layout>;
}
